import * as React from "react";
import { ContentBlock } from "../../ContentBlock/containers/ContentBlocks/ContentBlock/ContentBlock.js";
const CmsContentBlocks = ({ contentBlocks }) => /* @__PURE__ */ React.createElement(React.Fragment, null, contentBlocks.map((contentBlock, i) => /* @__PURE__ */ React.createElement(ContentBlock, { key: `${contentBlock.id}-${i}`, contentBlock })));
export {
  CmsContentBlocks as default
};
//# sourceMappingURL=ContentBlocks.js.map
